var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {
    'primary-button': _vm.classType === 'primary',
    'secondary-button': _vm.classType === 'secondary'
  }, _obj[_vm.customClass] = _vm.customClass, _obj ),style:({ color: _vm.textColor }),attrs:{"type":_vm.type,"disabled":_vm.disabledButton},on:{"click":function($event){_vm.onClick($event)}}},[_vm._t("default"),(_vm.loading)?_c('spinner',{attrs:{"line-fg-color":"#78FAAE"}}):[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]],2)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }